import cs from 'classnames';
import type { FC } from 'react';
import type { IBaseComponentProps, IProps } from '@/Module/Core/Model/DataModel';
interface IContainerProps extends IBaseComponentProps, IProps {}
const Container: FC<IContainerProps> = ({
  className,
  children
}) => <div className={cs('container', className)} data-sentry-component="Container" data-sentry-source-file="Container.tsx">{children}</div>;
export default Container;